function formatLocation({
  country,
  city,
}: {
  country?: string;
  city?: string;
}): string | undefined {
  if (country && city) {
    return `${city}, ${country}`;
  }
  if (country) {
    return country;
  }
  return undefined;
}

export { formatLocation };
